export function OnCallPage() {
  return (
    <div className="ac-page">
      <div className="ac-page-header">
        <div className="ac-page-header__left">
          <h1 className="ac-page-title">On-Call Management</h1>
          <p className="ac-page-subtitle">Manage on-call schedules and escalation policies</p>
        </div>
      </div>
      <div className="ac-table-wrap">
        <div className="ac-empty">
          <div className="ac-empty__icon">&#128222;</div>
          <div className="ac-empty__title">On-Call Management</div>
          <div className="ac-empty__body">On-call scheduling and escalation configuration coming soon.</div>
        </div>
      </div>
    </div>
  );
}
